import { render, staticRenderFns } from "./SpMenu.vue?vue&type=template&id=70ed5406&scoped=true&"
import script from "./SpMenu.vue?vue&type=script&lang=js&"
export * from "./SpMenu.vue?vue&type=script&lang=js&"
import style0 from "./SpMenu.vue?vue&type=style&index=0&id=70ed5406&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ed5406",
  null
  
)

export default component.exports